import { cn } from "~/lib/utils";

interface UserAvatarProps {
  userId: string | null | undefined;
  size?: number;
  className?: string;
  title?: string;
}

export const UserAvatar = ({ userId, size = 24, className, title }: UserAvatarProps) => {
  const letter = userId?.trim().charAt(0).toUpperCase() || "?";
  return (
    <div
      className={cn(
        "flex shrink-0 items-center justify-center rounded-full bg-muted font-medium uppercase text-muted-foreground",
        className
      )}
      style={{ width: size, height: size, fontSize: Math.round(size * 0.45) }}
      title={title}
      aria-hidden={title ? undefined : true}
    >
      {letter}
    </div>
  );
};
